import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigUrlService, SharedService } from '@ems/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestrictionSimulatorService {
  private configURL = this.config.setApplicationUrl();

  constructor(
    private httpService: HttpClient,
    private config: ConfigUrlService,
    private sharedService: SharedService
  ) {}

  submitTradeValidation(payload: any, headers: {[key: string]: string}, orgId: string, businessUnit: string): Observable<any> {
    const requestHeaders = new HttpHeaders(headers || {});
    let schwabClientHeader = [];
    const queryParamMap = this.sharedService.applicationInfo?.data?.queryParamMap || {};

    if (orgId) {
      schwabClientHeader = this.sharedService.setSchwabClientHeaders(queryParamMap.orgId, orgId, schwabClientHeader);
    }

    if (businessUnit) {
      schwabClientHeader = this.sharedService.setSchwabClientHeaders(queryParamMap.businessUnit, businessUnit, schwabClientHeader);
    }

    const url = this.configURL.bffTradeRestrictionEndPointV1 + '&Schwab-Client-Ids=' + schwabClientHeader;
    return this.httpService.post(url, payload, { headers: requestHeaders });
  }
}
